/* External dependencies */
import update from 'react-addons-update';

/* Local dependencies */
import { emailErrors } from '../../utils/emailValidationErrors';
import { GetEmailValidationActionTypes, EmailValidateActions } from './actions';

export interface EmailState {
  emailValue: string;
  error: string | null;
  isValid: boolean;
}

export const initialEmailState: EmailState = {
  emailValue: '',
  error: null,
  isValid: false,
};

export function emailValidateReducer(state: EmailState = initialEmailState, action: EmailValidateActions): EmailState {
  switch (action.type) {
    case GetEmailValidationActionTypes.EMAIL_INPUT:
      return update(state, {
        emailValue: { $set: action.emailValue },
        error: { $set: null },
      });

    case GetEmailValidationActionTypes.EMAIL_SUBMIT:
      const validationError = emailErrors(action.emailValue);
      if (validationError === null) {
        return update(state, {
          isValid: { $set: true },
        });
      }
      return update(state, {
        error: { $set: validationError },
      });

    case GetEmailValidationActionTypes.RESET_STATE:
      return update(state, {
        isValid: { $set: false },
        error: { $set: initialEmailState.error },
      });

    default:
      return state;
  }
}
